"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLocalTranslations = fetchLocalTranslations;
exports.getMobileTranslations = getMobileTranslations;
exports.getDesktopTranslations = getDesktopTranslations;
async function fetchLocalTranslations(request, localOrigin) {
    const origin = localOrigin || window.location.origin;
    const params = new URLSearchParams({
        language: request.language,
        scopes: request.scopes.join(","),
    });
    const response = await fetch(`${origin}/api/translations?` + params.toString(), {
        method: "GET",
    });
    if (!response.ok) {
        const filesList = request.scopes.map((s) => `translations/${s}.json`).join(",");
        throw new Error(`Failed to fetch local translations, make sure next files are valid: ${filesList}`);
    }
    return response.json();
}
async function getTranslations(config) {
    const { client, request, includeLocalTranslations, localOrigin, deviceType } = config;
    const translations = deviceType === "mobile"
        ? await client.getMobileTranslations(request)
        : await client.getDesktopTranslations(request);
    if (!includeLocalTranslations) {
        return translations;
    }
    const localTranslations = await fetchLocalTranslations(request, localOrigin);
    for (const scope in translations) {
        if (process.env.LOCAL_ONLY_TRANSLATIONS) {
            translations[scope] = {
                ...localTranslations[scope],
            };
        }
        else {
            translations[scope] = {
                ...localTranslations[scope],
                ...translations[scope],
            };
        }
    }
    return translations;
}
function getMobileTranslations(config) {
    return getTranslations({ ...config, deviceType: "mobile" });
}
function getDesktopTranslations(config) {
    return getTranslations({ ...config, deviceType: "desktop" });
}
//# sourceMappingURL=translations.js.map